import {
    request,
    requestPublic
} from './request.js'
// 获取专业列表页（不分页 50条)
export function getMajorList(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolMajor/GetMajorList',
        method: 'post',
        data: data
    })
}
//添加专业院校配置
export function addSchoolMajor(schoolId,ids) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolMajor/AddSchoolMajor?schoolId='+schoolId,
        method: 'post',
        data: ids
    })
}
//编辑专业院校配置
export function updateSchoolMajor(schoolId,ids) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolMajor/UpdateSchoolMajor?schoolId='+schoolId,
        method: 'post',
        data: ids
    })
}